var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xxzy-main"},[_c('div',{staticStyle:{"width":"600px","margin":"0 auto"}},[_c('img',{staticStyle:{"height":"100%","width":"100%"},attrs:{"src":require("../../../static/building_no_word.jpg"),"alt":""}}),_c('div',{staticStyle:{"font-size":"30px","color":"darkblue","height":"100px"}},[_vm._v(" The page is under construction, stay tuned. ")])])])
}]

export { render, staticRenderFns }